namespace TabAurous.OMS {
    export interface ProcessMasterForm {
        ItemTypeId: Serenity.LookupEditor;
        ProcessTypeId: Serenity.LookupEditor;
        ProcessCode: Serenity.StringEditor;
        ProcessName: Serenity.StringEditor;
        ProcessApplicableDetails: Serenity.LookupEditor;
        CalculateTo: Serenity.EnumEditor;
        IsSetting: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        SysParam: Serenity.BooleanEditor;
        InspectionDetails: ProcessInspectionEditor;
    }

    export class ProcessMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProcessMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProcessMasterForm.init)  {
                ProcessMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;
                var w4 = ProcessInspectionEditor;

                Q.initFormType(ProcessMasterForm, [
                    'ItemTypeId', w0,
                    'ProcessTypeId', w0,
                    'ProcessCode', w1,
                    'ProcessName', w1,
                    'ProcessApplicableDetails', w0,
                    'CalculateTo', w2,
                    'IsSetting', w3,
                    'IsDisabled', w3,
                    'SysParam', w3,
                    'InspectionDetails', w4
                ]);
            }
        }
    }
}
